import { getMiddlewareUrl } from './getMiddlewareUrl'

/**
 * Post offer click to middleware
 * @param {string} endpoint - API path "/api/offer/nerdwallet-lead"
 * @param {NerdwalletLead | null} leadData - NW lead object
 * @returns {Promise<OfferLeadResponse|void>}
 */
export async function sendOfferLead(endpoint, leadData) {
  const BASE_URL = getMiddlewareUrl()
  try {
    if (!leadData || Object.values(leadData).some((v) => v === null)) {
      return
    }

    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(leadData),
    })

    if (response.ok) {
      const data = await response.json()
      return data
    }
  } catch (error) {
    console.error('Error:', /** @type {Error} */ (error))
    throw new Error(error instanceof Error ? error.message : String(error))
  }
}
